import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  TRANSFERENCIAS_ENTRADA_DETALLE,
  TRANSFERENCIAS_ENTRADA_LISTA,
  TRANSFERENCIAS_SALIDA_DETALLE,
  TRANSFERENCIAS_SALIDA_NUEVO,
  TRANSFERENCIAS_SALIDA_LISTA,
  TRANSFERENCIAS_REPORTE
} from 'constants/codigosTransacciones'

import * as PorEntradaPages from './porEntrada'
import * as PorSalidaPages from './porSalida'
import ReportePage from './reportes'

export default function TransferenciasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${TRANSFERENCIAS_ENTRADA_DETALLE}/:idTransferencia`} component={PorEntradaPages.DetallePage} />
        <Route path={`/${TRANSFERENCIAS_ENTRADA_LISTA}`} component={PorEntradaPages.ListaPage} />
        <Route path={`/${TRANSFERENCIAS_SALIDA_DETALLE}/:idTransferencia`} component={PorSalidaPages.DetallePage} />
        <Route path={`/${TRANSFERENCIAS_SALIDA_NUEVO}`} component={PorSalidaPages.NuevoPage} />
        <Route path={`/${TRANSFERENCIAS_SALIDA_LISTA}`} component={PorSalidaPages.ListaPage} />
        <Route path={`/${TRANSFERENCIAS_REPORTE}`} component={ReportePage} />
      </Switch>
    </Suspense>
  )
}
